import React, { useEffect, useImperativeHandle, useState } from 'react'
import Modal from '../Modal'
import { Button, Input } from '../Elements';
import { formatCurrency } from '../../../lib/helpers';
import { replace } from 'formik';

type RefundModalProps = {
    amount: string;
    inputAmount: string;
    orderCode: string;
    currency: string;
    confirmCallBack: (inputAmount: any) => void;
}

const RefundModal = React.forwardRef(({ }, ref) => {

    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [modalValues, setModalValues] = useState({
        amount: "",
        inputAmount: "",
        orderCode: "",
        currency: "",
        confirmCallBack: (inputAmount: any) => { }
    });

    useImperativeHandle(ref, () => ({
        showRefund({ amount, inputAmount, orderCode, currency, confirmCallBack }: RefundModalProps) {
            setModalValues({ amount, inputAmount, orderCode, currency, confirmCallBack });
            setIsVisible(true);
            setErrorMessage("");
        },
        hideModal() {
            setIsVisible(false);
        }
    }));

    useEffect(() => {
        const sanitize = (val: any) => {
            if (typeof val === "number") return val;
            if (!val) return 0;
            return parseFloat(String(val).replace(",", ".")) || 0;
        };

        const parsedAmount = sanitize(modalValues.amount);
        const parsedInputAmount = sanitize(modalValues.inputAmount);


        if (parsedInputAmount < 1) {
            setErrorMessage(`İade tutarı en az 1 ${modalValues.currency} olmalıdır.`);
        } else if (parsedInputAmount > parsedAmount) {
            setErrorMessage(`İade tutarı toplam tutarı (${formatCurrency(parsedAmount)} ${modalValues.currency}) geçemez.`);
        } else {
            setErrorMessage("");
        }
    }, [modalValues.inputAmount, modalValues.amount, modalValues.currency]);


    return (
        <Modal openModal={isVisible} setOpenModal={setIsVisible}>
            <div>
                <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <div className="mt-4 flex flex-row items-center justify-center">
                            <img
                                className="text-error h-10 w-10"
                                src={"/icons/warning.svg"}
                                alt="warning"

                            />
                            <h3 className="text-md leading-6 font-medium text-gray-900">
                                Ödemeniz iade edilecek. Emin misiniz?
                            </h3>
                        </div>
                        <p className="ml-9 mr-9 mt-4 text-sm text-gray-500 text-left">
                            {modalValues.orderCode} numaralı ödemeniz için iade tutarı giriniz. İade tutarı, {formatCurrency(parseFloat(modalValues.amount))} ₺'yi geçemez.
                        </p>
                        <div className='mt-5 mb-2 w-full flex flex-row justify-around'>
                            <div className=" items-center">
                                <Input
                                    currencyformat="true"
                                    currencyicon={true}
                                    currencySymbol={modalValues.currency}
                                    type="number"
                                    name="refundAmount"
                                    value={modalValues.inputAmount}
                                    onChange={(e) => setModalValues({ ...modalValues, inputAmount: e.target.value, })}
                                    placeholder="İade tutarını giriniz"
                                    className='w-38'
                                    isTRCurrencyDisplay={true}
                                />
                                {errorMessage && (
                                    <p className="text-sm text-red-500 mt-2">{errorMessage}</p>
                                )}
                            </div>
                            <div className=" flex space-x-2">
                                <Button
                                    color="gray"
                                    hover="gray"
                                    size="xs"
                                    callback={() => setIsVisible(false)}
                                >
                                    Vazgeç
                                </Button>
                                <Button
                                    color="primary"
                                    hover="primary"
                                    size="xs"
                                    disabled={!!errorMessage}
                                    callback={() => {
                                        modalValues.confirmCallBack(modalValues.inputAmount);
                                        setIsVisible(false)
                                    }}
                                >
                                    İade Et
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
})

export default RefundModal